import { HttpClient } from '@angular/common/http';
import { Component, OnInit, forwardRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import * as _ from 'lodash';
import { NgForm, ControlContainer } from '@angular/forms';
import { ICardComponentInjectionToken } from '../../../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';
import { isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import DateHelpers from '../../../_infrastructure/DateHelpers';
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';
import { WorkflowComponent } from '../../workflow.component';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'cga-pension-status',
    templateUrl: './cga-pension-status.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    providers: [{ provide: ICardComponentInjectionToken, useExisting: forwardRef(() => CGAPensionStatusComponent) }],
    standalone: false
})
export class CGAPensionStatusComponent implements OnInit, ICardComponent {
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;
  public isWorkflowAgeLimit: boolean = false;
  public parentWorkflow: WorkflowComponent;

  //This information should come from subscriber/workflow contextualization
  //Mocked for now to allow development and testing
  public subscriber: models.SubscriberInformationVM;

  // Declaramos o cardData como get + set em vez de variável simples pois precisamos abaixo de agarrar lógica ao momento
  //  de atualização do cardData ( evita o ngDoCheck ou ngOnChanges ou afins )
  public get cardData(): models.CGAPensionStatusVM {
    return this._cardData;
  }
  public set cardData(value: models.CGAPensionStatusVM) {
    this._cardData = value;
    this.onCardDataChanged(); // Este é o método chamado quando temos mudança no cardData ( atualizado pelo step ), abaixo temos a implementação e a lógica
  }
  private _cardData: models.CGAPensionStatusVM = {} as models.CGAPensionStatusVM;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.quotaValue)
  public quotaValues: models.DimensionVM[];
  @CommonData(DomainCodes.professionalCategory)
  public professionalCategories: models.DimensionVM[];
  @CommonData(DomainCodes.workAssigment)
  public workAssignmentCodes: models.DimensionVM[];
  @CommonData(DomainCodes.limitAgesByProfCategory)
  public limitAgesByProfCategory: models.DimensionVM[];
  @CommonData(DomainCodes.subscriberType)
  public subscriberTypes: models.DimensionVM[];

  public parentMecanograficNumber = 0;
  public date73 = new Date(1973, 2, 1);
  public date91 = new Date(1991, 8, 1);
  public currentDate = new Date();
  public dateOfBirthPlus18 = new Date();
  public requestedByCGD: boolean;
  public isExSubscritor: boolean;


  constructor(private http: HttpClient, private activeRoute: ActivatedRoute, private subscriberInfoService: SubscriberInformationService, private stepDetailsService: StepDetailsService,) {
    this.stepDetailsService.workFlowCode
      .asObservable()
      .pipe(
        filter(el => el !== null && el !== undefined )
      )
      .subscribe(workflowCode => {
      this.isExSubscritor = (workflowCode.indexOf('PEDI008') == -1 && workflowCode.indexOf('PEDI005') == -1) ? false : true;
    });
  }

  private onCardDataChanged() {
    if (this.isVersion2()) {
      if (!this.isAfterStepSubscriberCGA()) {
        if (isNullOrUndefined(this.cardData.legalRetirementReason))
          this.cardData.legalRetirementReason = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.['legalRetirementReason'];
        if (isNullOrUndefined(this.cardData.legalSurvivalReason))
          this.cardData.legalSurvivalReason = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.['legalSurvivalReason'];
      } else {
        if (isNullOrUndefined(this.cardData.legalRetirementReason))
          this.cardData.legalRetirementReason = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.['legalRetirementReason'];
        if (isNullOrUndefined(this.cardData.legalSurvivalReason))
          this.cardData.legalSurvivalReason = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.['legalSurvivalReason'];
      }
      if (isNullOrUndefined(this.requestedByCGD))
        this.requestedByCGD = this.wasRequestedByCGD();
    }
  }

  getUTCDatePart(dt: Date) {
    return new Date(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate());
  }

  equalUTCDayDate(dt1: Date, dt2: Date) {

    return dt1.getUTCFullYear() === dt2.getUTCFullYear()
            && dt1.getUTCMonth() === dt2.getUTCMonth()
            && dt1.getUTCDate() === dt2.getUTCDate();
  }


  ngOnInit(): void {
    this.subscriberInfoService.getCurrentSubscriber().subscribe((subscriber) => this.subscriber = subscriber);
    this.currentDate.setDate(this.currentDate.getDate() - 1);
    this.dateOfBirthPlus18 = this.getDateOfBirthPlus18();
    if (!this.isWorkflowOnSubscriber) {
      this.retirementOnChange();
    }
    if (this.isVersion2()) {
      if (!this.isAfterStepSubscriberCGA()) {
        this.parentMecanograficNumber = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.['mecanograficNumber'];

        this.cardData.legalRetirementReason = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.['legalRetirementReason'];
        this.cardData.legalSurvivalReason = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.['legalSurvivalReason'];
      } else {

        this.parentMecanograficNumber = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.['mecanograficNumber'];

        this.cardData.legalRetirementReason = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.['legalRetirementReason'];
        this.cardData.legalSurvivalReason = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.['legalSurvivalReason'];
      }
    }
  }

  isVersion2() {
    return this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2';
  }

  isAfterStepSubscriberCGA() {
    return this.parentWorkflow.steps.some(s => s.stepCode === "StepSubscriberCGA");
  }

  wasRequestedByCGD(): boolean {
    return this.parentWorkflow.workflowInstance.formData['StepServiceInfo']['ServiceIdentification']['code'] === '2251';
  }

  dateOfBirthPlus12() {
    var result: Date = new Date(this.subscriber.dateOfBirth);
    result.setFullYear(result.getFullYear() + 12);
    result.setDate(result.getDate() + 1);
    return result;
  }

  getDateOfBirthPlus18() {
    var result: Date = new Date(this.subscriber.dateOfBirth);
    result.setFullYear(result.getFullYear() + 18);
    result.setDate(result.getDate() + 1);
    return result;
  }

  getRetirementTaxStartDate() {
    return new Date(this.cardData.retirementTaxStartDate);
  }

  // V1
  getSurvivalDate() {

    if (this.cardData.retirementTaxStartDate && this.cardData.retirementTaxStartDate < this.date73)
      return this.date73;

    return this.cardData.retirementTaxStartDate;

  }
  // End of V1

  // V2
  getMinSurvivalDate() {

    if (this.cardData.retirementTaxStartDate && this.cardData.retirementTaxStartDate < this.date73)
      return this.date73;

    return this.cardData.retirementTaxStartDate;

  }
  getMaxSurvivalDate() {

    if (this.cardData.retirementTaxStartDate && this.cardData.retirementTaxStartDate < this.date73)
      return this.date91;

    return this.cardData.retirementTaxStartDate;

  }
  // End of V2
  manualValidation(dpTest) {
 
    if (dpTest._elRef.nativeElement.value.length < 4) {
      dpTest.setErrors({
        "minDate": true
      })
    }

  }


  getDatePlusDays(date : Date , days): Date  {
    var result: Date = new Date(date);
    result.setDate(date.getDate() + days);
    return result;
  }

  disabledDates() {
    var getDaysArray = function (s, e) { for (var a = [], d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) { a.push(new Date(d)); } return a; };
    var daylist = getDaysArray(new Date("1973-03-01"), new Date("1991-09-01"));
    return daylist;
  }

  isStepSubSituation() {
    return this.cardConfiguration.stepCode == 'CGA01SubSituation' && !this.isWorkflowOnSubscriber;
  }

  getFilteredProfessionalCategories() {
    if (this.parentWorkflow.workflowVersion?.toString() === '1' || this.parentWorkflow.workflowVersion === undefined) {
      if (!isNullOrUndefined(this.cardData.subscriberTypeCode)) {
        return this.professionalCategories.filter(profCat => profCat.value == this.cardData.subscriberTypeCode);
      } else {
        return this.professionalCategories;
      }
    } else if (this.parentWorkflow.workflowVersion.toString() === '2') {
      let result = [];
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === 'dropListProfessionalC' && this.cardData?.subscriberTypeCode === this.parentWorkflow.workflowDropdowns.options[i]?.type) {
          result.push(this.parentWorkflow.workflowDropdowns.options[i]);
        }
      }
      return result;
    }

  }

  subscriberTypeCodeChanged() {
    if (this.cardData.subscriberTypeCode.toString() !== '02') { this.cardData.mecanograficNumber = null; }
    else {
      this.cardData.mecanograficNumber = this.parentMecanograficNumber;
    }
    if (this.parentWorkflow.workflowInstance.workflowCode == "PEDI0020") {

    }
  }

  professionCategoryChanged() {
    if (!isNullOrUndefined(this.cardData.professionalCategoryCode)) {
      var limitDateDimensionIndex = this.limitAgesByProfCategory.findIndex(x => x.code == this.cardData.professionalCategoryCode);
      if (limitDateDimensionIndex != -1) {
        this.cardData.retirementLimitAgeCode = this.limitAgesByProfCategory[limitDateDimensionIndex].code;
        var dimensionValue = parseInt(this.limitAgesByProfCategory[limitDateDimensionIndex].value);
        var date = new Date(this.subscriber.dateOfBirth.getTime());
        var tempDate = new Date(Date.UTC(date.getFullYear()+ dimensionValue,date.getMonth(),date.getDate()));
        this.cardData.retirementLimitDate = tempDate;  
      }
      if (this.isVersion2()) {
        let ageLimits = this.getAgeLimits();
        for (let i = 0; i < ageLimits.length; i++) {
          if (ageLimits[i].value === this.cardData.professionalCategoryCode) {
            this.cardData.retirementLimitAgeCode = ageLimits[i].value;
            var result: Date = new Date(this.subscriber.dateOfBirth);
            let ageLimit = new Number(ageLimits[i].filter).valueOf();
            result.setFullYear(result.getFullYear() + ageLimit);
            this.cardData.retirementLimitDate = result;
          }
        }
        if (this.cardData.professionalCategoryCode !== '5') {
          this.cardData.cejRegisterDate = undefined;
        }
        //remun fields reseted on professionalCategory change
        if (this.parentWorkflow.workflowInstance.formData['StepRenum']['RemunerationsLastUntilCutoff'] !== undefined) { 
          this.parentWorkflow.workflowInstance.formData['StepRenum']['RemunerationsLastUntilCutoff']['category'] = undefined;
          this.parentWorkflow.workflowInstance.formData['StepRenum']['RemunerationsLastUntilCutoff']['taxStep'] = undefined;
          this.parentWorkflow.workflowInstance.formData['StepRenum']['RemunerationsLastUntilCutoff']['taxIndex'] = undefined;
        }
        if (this.parentWorkflow.workflowInstance.formData['StepRenum']['RemunerationsCurrentMonthly'] !== undefined) {
          this.parentWorkflow.workflowInstance.formData['StepRenum']['RemunerationsCurrentMonthly']['categoryM'] = undefined;
        }
        
      }
    }
    this.cardData.retirementLimitDate
  }

  retirementOnChange() {
    //if (this.cardData.retirementTaxStartDate) {
    //  this.cardData.retirementTaxStartDate = this.cardData.retirementTaxStartDate;
    //}
    if (this.isVersion2) {
      if (this.cardData.retirementTaxStartDate && this.cardData.retirementTaxStartDate < this.date73) {
        if (this.cardData.survivalTaxStartDate > this.date91 || this.cardData.survivalTaxStartDate < this.date73) {
          this.cardData.survivalTaxStartDate = this.date73;
        }
      } else {
        this.cardData.survivalTaxStartDate = this.cardData.retirementTaxStartDate;
      }
    } else {
      if (this.cardData.retirementTaxStartDate && this.cardData.retirementTaxStartDate < this.date73) {
        this.cardData.survivalTaxStartDate = this.date73;
      } else {
        this.cardData.survivalTaxStartDate = this.cardData.retirementTaxStartDate;
      }
    }
  }

  getlegalRetirementReasons() {
    let result = [];
    for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++){
      if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === 'dropListAP') {
        result.push(this.parentWorkflow.workflowDropdowns.options[i]);
      }
    }
    return result;
  }

  getlegalSurvivalReasons() {
    let result = [];
    for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
      if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === 'dropListSO') {
        result.push(this.parentWorkflow.workflowDropdowns.options[i]);
      }
    }
    return result;
  }

  getAgeLimits() {
    let result = [];
    for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
      if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === 'dropListProfessionalC') {
        result.push(this.parentWorkflow.workflowDropdowns.options[i]);
      }
    }
    return result;
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    let object = new Date(this.cardData[event.target.name]).toISOString().split('T')[0];
    DateHelpers.onDateChange(event, dp, object);
  }
  
}
